import ChecklistFormItem from './_checklist_form_item';

const InquiryItem = ChecklistFormItem.extend({
});

export default InquiryItem;
